/* ---- Be Neo MindMag — caixa de compra e galeria da PDP ---------------------
   Le o mesmo `#lp-offer-data` que as LPs e o beneo-buybox usam: preco, preco
   riscado e frete saem da loja, nunca daqui. Mudou no admin, muda na pagina.

   Por que nao reaproveitei o beneo-buybox.js: aquele e da PDP do LymphoDrain,
   que esta no ar com trafego pago, e assume selling plan e brindes — nenhum dos
   dois existe aqui. Mexer nele para caber 1/3/5 sem assinatura era arriscar a
   pagina que ja vende para servir a que ainda nao vendeu.

   O mockup nao tinha nada disto: os tres cards de pacote eram HTML morto e o
   botao dizia $79.99 fixo. Ver docs/13-landing-pages.md.
   -------------------------------------------------------------------------- */
(function () {
  var D = {};                    /* qty -> {variantId, once, compare, ship, avail} */
  var QTYS = [];                 /* quantidades na ordem em que a loja devolveu */
  var qty = 0;

  /* Na moeda do visitante (Markets): '$' nos EUA, '£' no Reino Unido. O valor
     ja vem convertido pelo Liquid; aqui so troca o simbolo. */
  function usd(n) {
    var c = window.Shopify && Shopify.currency && Shopify.currency.active;
    return ({ GBP: '\u00a3', EUR: '\u20ac' }[c] || '$') + n.toFixed(2);
  }

  function read() {
    var el = document.getElementById('lp-offer-data');
    if (!el) return false;
    var raw;
    try { raw = JSON.parse(el.textContent); } catch (e) { return false; }
    if (!raw || !raw.items || !raw.items.length) return false;
    raw.items.forEach(function (it) {
      if (!it.qty) return;
      D[it.qty] = {
        variantId: it.variantId,
        once: it.oncePrice / 100,
        compare: it.comparePrice ? it.comparePrice / 100 : null,
        ship: parseFloat(it.ship) || 0,
        avail: it.available !== false
      };
      QTYS.push(it.qty);
    });
    return QTYS.length > 0;
  }

  /* Card marcado com data-mm-default manda; sem ele, o do meio. */
  function pickDefault() {
    var flagged = document.querySelector('[data-mm-qty][data-mm-default]');
    if (flagged && D[+flagged.dataset.mmQty]) return +flagged.dataset.mmQty;
    return QTYS[Math.floor(QTYS.length / 2)] || QTYS[0];
  }

  function render() {
    var d = D[qty];
    if (!d) return;

    document.querySelectorAll('[data-mm-qty]').forEach(function (card) {
      var q = +card.dataset.mmQty, k = D[q];
      card.setAttribute('aria-selected', q === qty);
      if (!k) { card.hidden = true; return; }

      var price = card.querySelector('[data-mm-price]');
      if (price) price.textContent = usd(k.once);

      var was = card.querySelector('[data-mm-was]');
      if (was) {
        if (k.compare && k.compare > k.once) { was.textContent = usd(k.compare); was.hidden = false; }
        else { was.hidden = true; }
      }

      var save = card.querySelector('[data-mm-save]');
      if (save) {
        if (k.compare && k.compare > k.once) {
          save.textContent = 'Save ' + Math.round((1 - k.once / k.compare) * 100) + '%';
          save.hidden = false;
        } else { save.hidden = true; }
      }

      var per = card.querySelector('[data-mm-per]');
      if (per) per.textContent = usd(k.once / q) + ' a bottle';
    });

    var btn = document.getElementById('mm-buy');
    if (btn) {
      var label = 'ADD TO CART · ' + usd(d.once);
      btn.innerHTML = '';
      btn.appendChild(document.createTextNode(label));
      if (d.compare && d.compare > d.once) {
        var s = document.createElement('span');
        s.className = 'was';
        s.textContent = usd(d.compare);
        btn.appendChild(s);
      }
      btn.disabled = !d.avail;
    }

    var note = document.getElementById('mm-ship');
    if (note) {
      note.innerHTML = d.ship > 0
        ? 'Shipping ' + usd(d.ship) + ' — <b>free on 3 and 5 bottles</b>'
        : '<b>Free US shipping</b> on this bundle';
    }
  }

  function say(msg) {
    var el = document.getElementById('mm-err');
    if (el) { el.textContent = msg; el.hidden = false; }
  }

  /* ---- O que o comprador ve no CHECKOUT -----------------------------------
     A loja esta no plano Shopify, nao Plus: a Checkout Branding API responde
     ACCESS_DENIED e extension nas etapas do checkout e exclusiva do Plus (ver
     admin/checkout/README.md). O que funciona em QUALQUER plano e propriedade
     de item de carrinho: chave sem `_` na frente aparece embaixo do nome do
     produto no resumo do pedido, no e-mail de confirmacao e no pedido do admin.

     Sem isso o checkout dizia so "Be Neo MindMag / 5 Bottles / $119.99" — a
     oferta que convenceu a pessoa na PDP sumia na hora de pagar.

     Todo numero aqui e CALCULADO a partir do #lp-offer-data, nunca escrito:
     mudou o preco no admin, muda aqui junto. E o rotulo da oferta sai do texto
     do proprio card selecionado, para nao existirem duas redacoes da mesma
     promocao. -------------------------------------------------------------- */
  function oferta(d) {
    var props = {};
    var card = document.querySelector('[data-mm-qty="' + qty + '"]');
    var titulo = card && card.querySelector('.b-title');

    /* So e "oferta" quando ha mais de um frasco: em Buy 1 nao ha o que anunciar. */
    if (titulo && qty > 1) {
      props['Your offer'] = titulo.textContent.trim() + ' \u2014 ' + qty + ' bottles';
    }
    props['Price per bottle'] = usd(d.once / qty);
    if (d.compare && d.compare > d.once) {
      var economia = d.compare - d.once;
      var pct = Math.round(economia / d.compare * 100);
      props['You save'] = usd(economia) + ' (' + pct + '% off ' + usd(d.compare) + ')';
    }
    return props;
  }

  /* Comprar SUBSTITUI o carrinho, nao soma (assets/carrinho-substitui.js):
     esvazia antes de adicionar e ignora o toque duplo. Sem aquele arquivo na
     pagina, compra como antes — o fetch direto. */
  function adicionar(items) {
    var cs = typeof window !== 'undefined' && window.carrinhoSubstitui;
    if (cs) return cs.adicionar(items);
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) { return r.ok ? r.json() : r.json().then(function (e) { throw e; }); });
  }

  function buy(ev) {
    if (ev) ev.preventDefault();
    var d = D[qty];
    if (!d) return say('Pick a bundle');

    var btn = document.getElementById('mm-buy');
    if (btn) btn.setAttribute('aria-busy', 'true');

    adicionar([{ id: d.variantId, quantity: 1, properties: oferta(d) }])
      .then(function () { window.location.href = '/checkout'; })
      .catch(function (e) {
        if (btn) btn.removeAttribute('aria-busy');
        console.error('[brainmag-pdp] /cart/add.js falhou', e);
        say((e && e.description) || 'Could not add to cart — try again');
      });
  }

  /* ---- Galeria: slides, nao troca de src, para o srcset do beneo-img valer --
     Com 8 imagens (02/09/2026, antes 6) a miniatura sozinha nao da conta: no
     celular a fila rola de lado e as ultimas ficam fora da tela, entao quem so
     olha nem descobre que ha mais imagem. Dai as setas, o contador e o arrasto.
     -------------------------------------------------------------------------- */
  function gallery() {
    var slides = document.querySelectorAll('[data-mm-slide]');
    var thumbs = document.querySelectorAll('[data-mm-thumb]');
    var strip = document.querySelector('.thumbs');
    var count = document.querySelector('[data-mm-count]');
    var prev = document.querySelector('[data-mm-prev]');
    var next = document.querySelector('[data-mm-next]');
    var main = document.querySelector('.gallery-main');
    if (!slides.length) return;

    var at = 0;

    function show(i) {
      at = (i + slides.length) % slides.length;   /* circula nas duas pontas */
      slides.forEach(function (s, n) { s.setAttribute('data-on', n === at ? '1' : '0'); });
      thumbs.forEach(function (t, n) { t.setAttribute('aria-selected', n === at); });
      if (count) count.textContent = (at + 1) + ' / ' + slides.length;

      /* Centraliza a miniatura ativa na fila. So mexe no scroll HORIZONTAL da
         propria fila — scrollIntoView aqui arrastaria a pagina inteira. */
      var t = thumbs[at];
      if (t && strip && strip.scrollWidth > strip.clientWidth + 2) {
        strip.scrollTo({
          left: Math.max(0, t.offsetLeft - (strip.clientWidth - t.offsetWidth) / 2),
          behavior: 'smooth'
        });
      }
    }

    thumbs.forEach(function (t, n) { t.addEventListener('click', function () { show(n); }); });
    if (prev) prev.addEventListener('click', function () { show(at - 1); });
    if (next) next.addEventListener('click', function () { show(at + 1); });

    /* Arrastar o dedo na imagem grande. Os 40 px de folga e a comparacao com o
       eixo Y existem para nao roubar o scroll de quem so esta descendo a pagina. */
    if (main) {
      var x0 = null, y0 = 0;
      main.addEventListener('touchstart', function (e) {
        x0 = e.touches[0].clientX; y0 = e.touches[0].clientY;
      }, { passive: true });
      main.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0;
        var dy = e.changedTouches[0].clientY - y0;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) show(at + (dx < 0 ? 1 : -1));
        x0 = null;
      }, { passive: true });
    }

    show(0);
  }

  /* ---- Contagem regressiva do topo ----------------------------------------
     Sessao, nao data: um prazo real que expirasse deixaria a barra em 00:00:00
     no dia seguinte, que e pior do que nao ter barra. Reinicia a cada visita. */
  function timer() {
    var box = document.getElementById('mm-timer');
    if (!box) return;
    var left = (parseInt(box.dataset.minutes, 10) || 10) * 60;
    var h = box.querySelector('[data-t-h]'),
        m = box.querySelector('[data-t-m]'),
        s = box.querySelector('[data-t-s]');
    function pad(n) { return n < 10 ? '0' + n : '' + n; }
    function tick() {
      if (left <= 0) { left = (parseInt(box.dataset.minutes, 10) || 10) * 60; }
      if (h) h.textContent = pad(Math.floor(left / 3600));
      if (m) m.textContent = pad(Math.floor(left / 60) % 60);
      if (s) s.textContent = pad(left % 60);
      left--;
    }
    tick();
    setInterval(tick, 1000);
  }

  function init() {
    gallery();
    timer();
    if (!read()) return;
    qty = pickDefault();
    document.querySelectorAll('[data-mm-qty]').forEach(function (card) {
      card.addEventListener('click', function () { qty = +card.dataset.mmQty; render(); });
    });
    var b = document.getElementById('mm-buy');
    if (b) b.addEventListener('click', buy);
    /* Voltou do checkout pelo "voltar" (pagina restaurada do bfcache): o botao
       ficou marcado como ocupado. Sem isto ele pareceria travado. */
    if (typeof window !== 'undefined' && window.addEventListener) {
      window.addEventListener('pageshow', function (e) {
        if (e.persisted && b) b.removeAttribute('aria-busy');
      });
    }
    render();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
